<template>
    <div
        class="option-btn-group-v2 option-btn-tall pb-5"
        :class="btnGridColsClass"
    >
        <template
            v-for="(opt, index) in option.groupValues"
            :key="`item-${index}`"
        >
            <v-btn
                class="rounded selected"
                :class="{
                    'no-event': noEvent
                }"
                variant="outlined"
                :block="block"
            >
                <div
                    class="text-center d-flex flex-column align-center justify-center"
                >
                    <div class="d-flex flex-row align-center justify-center">
                        <ColorSwatch
                            v-if="opt.value.colors?.length"
                            class="mr-2"
                            :color="opt.value.colors"
                        ></ColorSwatch>
                        <strong>{{ opt.value.name }}</strong>
                    </div>
                    <div
                        v-if="opt.value.description"
                        class="sub-text"
                    >
                        {{ opt.value.description }}
                    </div>
                </div>
            </v-btn>
            <input
                type="hidden"
                :name="name"
                v-model="model"
            />
        </template>
    </div>
</template>

<script lang="ts" setup>
    import ColorSwatch from '~/components/color/ColorSwatch/ColorSwatch.vue';
    import type { ProductAttrsGroupOption } from '~/types';


    const props = withDefaults(
        defineProps<{
            modelValue: string;
            option: ProductAttrsGroupOption;
            name?: Undefinable<string>;
            block?: boolean;
            noEvent?: boolean;
        }>(),
        {
            name: ''
        }
    );

    const model = ref(props.modelValue);
    const unWatchValue = watch(
        () => props.modelValue,
        (newVal) => {
            model.value = newVal;
        }
    );

    const btnGridColsClass = computed<string>(() => props.option.groupValues.length === 1 ? 'g-col-1' : '');

    onBeforeUnmount(() => {
        unWatchValue();
    });
</script>

<style lang="scss" scoped></style>
